<script>
    import ApexCharts from 'apexcharts'
    import { onMount } from 'svelte'
    import { statisticsStore } from '../../stores/Statistics'
    import { t } from 'totalinvoice-frontend-core'
    import { Button }  from 'totalinvoice-frontend-core'

    let container
    let chart

    const date_start = new Date("01 Sept 2020").getTime()
    const date_pilot = new Date("02 Nov 2020").getTime()
    const date_live = new Date("26 May 2021").getTime()
    const date_now = new Date()

    const options = {
        series: [],
        noData: {
            text: $t('Loading...'),
        },
        chart: {
            id: 'area-datetime',
            type: 'area',
            height: 350,
            zoom: {
                autoScaleYaxis: true
            },
            defaultLocale: 'en',
        },
        annotations: {
            /*yaxis: [{
                y: 30,
                borderColor: '#999',
                label: {
                show: true,
                text: 'Support',
                style: {
                color: "#fff",
                background: '#00E396'
                }
                }
            }],*/
            xaxis: [{
                x: date_live,
                borderColor: '#999',
                yAxisIndex: 0,
                label: {
                show: true,
                text: 'Live',
                style: {
                color: "#fff",
                background: '#775DD0'
                }
                }
            }, {
                x: date_pilot,
                borderColor: '#999',
                yAxisIndex: 0,
                label: {
                show: true,
                text: 'Pilot',
                style: {
                color: "#fff",
                background: '#775DD0'
                }
                }
            }]
        },
        dataLabels: {
            enabled: false
        },
        markers: {
            size: 0,
            style: 'hollow',
        },
        xaxis: {
            type: 'datetime',
            min: date_start,
            max: date_now,
        },
        yaxis: {
            tickAmount: 1,
        },
        tooltip: {
            x: {
                format: 'dd MMM yyyy'
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 100]
            }
        },
    }

    $: if ($statisticsStore.invoicesByDay.data && chart) {
        const series = $statisticsStore.invoicesByDay

        // translate name of series
        series.name = $t(series.name)

        chart.updateSeries([series])
    }

    onMount(() => {
        chart = new ApexCharts(container, options)
        chart.render()
    })

    function showOneMonth() {
        const from = new Date(date_now)
        from.setMonth(date_now.getMonth() - 1)
        chart.zoomX(from.getTime(), date_now.getTime())
    }

    function showSixMonths() {
        const from = new Date(date_now)
        from.setMonth(date_now.getMonth() - 6)
        chart.zoomX(from.getTime(), date_now.getTime())
    }

    function showMonthToDate() {
        const from = new Date(date_now.getFullYear(), date_now.getMonth(), 1);
        chart.zoomX(from.getTime(), date_now.getTime())
    }

    function showOneYear() {
        const from = new Date(date_now)
        from.setFullYear(date_now.getFullYear() - 1)
        chart.zoomX(from.getTime(), date_now.getTime())
    }

    function showYearToDate() {
        const from = new Date(date_now.getFullYear(), 0, 1);
        chart.zoomX(from.getTime(), date_now.getTime())
    }

    function showAll() {
        chart.zoomX(date_start, date_now.getTime())
    }
</script>

<div class="buttons are-small is-right">
    <Button type='is-link is-outlined' on:click={showOneMonth}>
        {$t('1 Month')}
    </Button>
    <Button type='is-link is-outlined' on:click={showSixMonths}>
        {$t('6 Months')}
    </Button>
        <Button type='is-link is-outlined' on:click={showMonthToDate}>
        {$t('Current month')}
    </Button>
        <Button type='is-link is-outlined' on:click={showOneYear}>
        {$t('1 Year')}
    </Button>
    <Button type='is-link is-outlined' on:click={showYearToDate}>
        {$t('Current year')}
    </Button>
    <Button type='is-link is-outlined' on:click={showAll}>
        {$t('All')}
    </Button>
</div>

<div bind:this={container} />
